export { default } from "./ClientInfoFull";



// WEBPACK FOOTER //
// ./src/components/emission/ClientInfoFull/index.js